import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import * as reportes from "../../actions/reports";
import Layout from "../../components/layout";
import PartnerMembershipTrasfersReport from "../../components/partnerMembershipTransferReport";
import IAction from "../../../types/IAction";

interface Props {
  downloadReportPartnerMembershipDirectory: (params: any) => IAction;
  userContext: { clubSessionId: any };
}

class PartnerMembershipTransfersReportPage extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Directorio de traspasos" />
        <Layout>
          <PartnerMembershipTrasfersReport
            downloadReportPartnerMembershipTransfers={
              this.props.downloadReportPartnerMembershipTransfers
            }
            userContext={this.props.userContext}
          />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    userContext: user.userContext
  };
};

const mapDispatchToProps = dispatch => ({
  downloadReportPartnerMembershipTransfers: params => {
    dispatch(reportes.downloadReportPartnerMembershipTransfers(params));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerMembershipTransfersReportPage);
